import { UserSettings } from "./_UserSettings";
import { ChangePasswordSection } from "./ChangePasswordSection";

export function ProfileSection() {
  return (
    <>
      <UserSettings />
      <ChangePasswordSection />
    </>
  );
}
